/**
 * send to ga
 *
 * this function will send a notification to google analytics if google analytics is defined
 * else it will do nothing
 *
 * @author damir djikic
 * @param action
 * @param label
 * @param value
 * @param implicitount
 * @param event
 */
function send_ga(action, label, value, implicitount, event) {
  if (typeof gtag !== 'undefined') {
    implicitount = typeof implicitount !== 'undefined' ? implicitount : value;

    gtag('event', value, {
      event_category: label,
      event_label: implicitount,
    });

    console.log('GA send:event:' + label + ':' + value + ':' + implicitount);
    return true;
  }
  return false;
}

function checkRightClick(event) {
  if (
    window.location.pathname.indexOf('/editor') !== 0 &&
    !(
      event.target &&
      event.target.classList &&
      typeof event.target.classList === 'object' &&
      event.target.classList.contains('right-clickable')
    )
  ) {
    event.preventDefault();
    return false;
  }
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
